import axios from 'axios';
import _get from 'lodash/get';
import { QuotaExceededError, DataServiceError } from '../errors';
import getItem from '../utils/storage';

const handleError = error => {
  const status = _get(error, 'response.status');
  switch (status) {
    case 429:
      throw new QuotaExceededError();
    case 500:
    case 502:
    case 503:
    case 504:
      throw new DataServiceError();
    default:
      throw new Error(`Error with data service: ${error.message || 'Unknown'}`);
  }
};

const fetchData = async (url, usageKey, config) => {
  if (!usageKey) {
    console.log('Using dummy data (no usage key specified)');
    return await import('../../demo/dummy_data' /* webpackChunkName: "dummy-data" */).then(
      data => ({
        results: data.default
      })
    );
  }

  try {
    const { data: response } = await axios.post(url, config, {
      headers: { 'x-api-key': usageKey }
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const extractParams = (config, credentials) => {
  const {
    type,
    other_timeline,
    words,
    filter,
    display,
    display_retweets,
    display_replies,
    blacklist,
    time_window
  } = config;
  const { access_token, access_token_secret } = credentials;
  return {
    type,
    other_timeline,
    words,
    filter,
    display,
    display_retweets,
    display_replies,
    blacklist,
    time_window,
    access_token,
    access_token_secret
  };
};

export default {
  getData: async (usageKey, config, credentials) => {
    if (getItem('error') === 'data') {
      throw new DataServiceError();
    }
    const { results } = await fetchData(
      process.env.DATA_SERVICE_URL,
      usageKey,
      extractParams(config, credentials)
    );
    return {
      results,
      ready: true
    };
  },
  getModeration: async (usageKey, config, credentials) => {
    const { tweets, moderation } = await fetchData(
      process.env.DATA_MODERATION_URL,
      usageKey,
      extractParams(config, credentials)
    );
    return {
      tweets,
      moderation
    };
  },
  saveModeration: async (usageKey, config, credentials, moderation) => {
    try {
      const payload = Object.assign({}, extractParams(config, credentials), { moderation });
      const { data: response } = await axios.put(process.env.DATA_MODERATION_URL, payload, {
        headers: { 'x-api-key': usageKey }
      });
      return response.data;
    } catch (error) {
      handleError(error);
    }
  }
};
